export default __webpack_public_path__ + "static/media/contact_img.40f77c7a.webp";